import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const UpcomingInterview = ({ name, desg, slot, id, status, payment }) => {
  if (payment === false) {
    return;
  }
  return (
    <>
      <div className="relative sent-item my-4 p-2 overflow-hidden">
        {/* Updated */}
        {/* <div className="absolute h-full w-full" id="updated">
          <div className="flex justify-center items-center h-full bg-gray-500/50">
            <div className="px-4 py-2 bg-green-500 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Updated
              </Typography>
            </div>
          </div>
        </div> */}

        {/* Canceled */}
        {/* <div className="absolute h-full w-full" id="canceled">
          <div className="flex justify-center items-center h-full bg-gray-500/50">
            <div className="absolute text-2xl top-2 right-2 text-red-600 cursor-pointer hover:text-red-800">
              <i className="fa-solid fa-circle-xmark"></i>
            </div>
            <div className="px-4 py-2 bg-red-600 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Canceled
              </Typography>
            </div>
          </div>
        </div> */}
        <div className="sent-item-profile">
          <img src={require("../../../images/photo.png")} alt="Profile" />
          <button className="cust-btn sent-view-btn">View Profile</button>
        </div>
        <div className="sent-item-info">
          <div className="px-3">
            <div>
              <div className="flex py-1 justify-between w-full">
                <div className="flex gap-x-2">
                  <div className="interviewer-logo">
                    <img
                      src={require("../../../images/amazon.png")}
                      alt="google"
                    />
                  </div>
                  <div>
                    <div>
                      <h4 className="text-2xl text-left font-medium leading-6">
                        {name}
                      </h4>
                      <p>{desg}</p>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2">
                  <div className="flex justify-center h-10 text-blue-500 text-2xl">
                    <Button variant="contained">
                      <i className="fa-solid fa-link mr-1"></i> Resume
                    </Button>
                  </div>
                  <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                    <i className="fa-solid fa-bookmark"></i>
                  </div>
                  <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                    <i className="fa-solid fa-share"></i>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-4 text-center my-1 gap-x-4 mx-2">
                <div>
                  <p className="text-base text-gray-400">Profile</p>
                  <p className="text-lg">Data Science</p>
                </div>
                <div>
                  <p className="text-base text-gray-400">Price</p>
                  <p className="text-lg">INR 1200</p>
                </div>
                <div>
                  <p className="text-base text-gray-400">Session Duration</p>
                  <p className="text-lg">45 Min</p>
                </div>
                <div>
                  <p className="text-base text-gray-400">Interview Slot</p>
                  <p className="text-lg">{slot}</p>
                  <p className="text-lg">20 June, 2022</p>
                </div>
              </div>
              <div className="sent-item-btns flex justify-center">
                <div className="meeting-id">Mock Interview ID: #342B14CD9</div>
                <button type="button" className="cust-btn join-meeting-btn">
                  Join Meeting
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UpcomingInterview;
